"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    //simple
    {
        key: 'defaultValue',
        ignore: true
    },
    {
        key: 'persistent ',
        ignore: true
    },
    {
        type: 'select',
        input: true,
        weight: 3,
        tooltip: 'Select data type you\'d like to use.',
        key: 'dataType',
        defaultValue: 'aripost',
        label: 'Chart type',
        dataSrc: 'values',
        data: {
            values: [
                { label: 'Custom', value: 'custom' },
                { label: 'Post from Ari', value: 'aripost' },
            ],
        },
    },
    {
        type: 'textfield',
        inputType: 'url',
        key: 'aricallchartdata',
        input: true,
        weight: 5,
        label: 'API for chart data',
        tooltip: 'insert API link to get data chart',
        placeholder: 'bo/bank/list',
        defaultValue: '',
        conditional: {
            json: { '===': [{ var: 'data.dataType' }, 'aripost'] },
        },
    },
    //simple
    {
        type: 'datagrid',
        key: 'aribody',
        input: true,
        weight: 6,
        label: 'Request message body',
        addAnother: 'Add Node',
        tooltip: 'JSON body message structure',
        components: [
            {
                key: 'path',
                label: 'Path',
                input: true,
                type: 'textfield',
            },
            {
                type: 'select',
                key: 'type',
                label: 'Type',
                input: true,
                dataSrc: 'values',
                data: {
                    values: [
                        { label: 'Value', value: 'value' },
                        { label: 'Data', value: 'data' },
                        { label: 'Script', value: 'script' },
                    ],
                },
                defaultValue: 'data'
            },
            {
                key: 'value',
                label: 'Value',
                input: true,
                //rows: 3,
                //editor: 'ace',
                as: 'javascript',
                type: 'textarea',
                attributes: {
                    style: 'height:calc(1.5em + .75rem + 2px)',
                },
                placeholder: '',
            }
        ],
        conditional: {
            json: { '===': [{ var: 'data.dataType' }, 'aripost'] },
        },
    },
    {
        type: 'textarea',
        input: true,
        key: 'customDataChart',
        label: 'Data chart',
        editor: 'ace',
        as: 'javascript',
        rows: 3,
        weight: 18,
        tooltip: 'can use javascript to create data for chart ',
        placeholder: `
    dataChart:{
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [{
          label: "My First dataset",
          backgroundColor: "rgba(255,99,132,0.2)",
          borderColor: "rgba(255,99,132,1)",
          borderWidth: 1,
          data: [65, 59, 80, 81, 56, 55, 40],
      }]
    }`,
    },
];
